<div class="ribbon">
  <div class="upper-curve"></div>
  <h2>
    <div [innerHTML]="offer | safeHtml"></div>
  </h2>
  <div class="lower-curve"></div>
</div>